import { convertNumericMonthToName } from "core/utils/transaction.utils";
import { useQuery } from "@tanstack/react-query";
import { useClientContext } from "clients";
import { useStateContext } from "state";

/**
 * Custom hook to fetch reconciliations reports for a specific account and type.
 *
 * @param {string} transactionType - The type of transactions to filter (e.g., 'all-disposition').
 * @param {string} id - The ID of the account to fetch reports for.
 * @returns {Object} { data, isLoading, isSuccess }
 */
const useGetReconciliationsReportsList = (transactionType: string, id: string) => {
    const clients = useClientContext();
    const state = useStateContext();

    return useQuery({
        queryKey: [id, transactionType],
        enabled: !!state.user,
        queryFn: async () => {
            const res = await clients.management.getReconciliationReportsList('reconciliations', id);

            return res.map((item) => ({
                id: item.id,
                currentMonth: new Date().getMonth() + 1 === item.month,
                month: convertNumericMonthToName(item.month),
                year: item.year,
                status: item.status,
                created_at: item.created_at,
            }));
        },
    });
};

export default useGetReconciliationsReportsList;
